// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-id-pdf-generator-modal .modal2__container{
width: 80%;
}

.card-id-pdf-generator-modal__mobile-options {
    padding: 50px 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-id-pdf-generator-modal__loading {
    margin-top: 140px;
    text-align: center;
}

.card-id-pdf-generator-modal__loading .hubicon-id_card {
    font-size: 40px;
    padding: 16px;
    background: #DCFCE7;
    border-radius: 50%;
}

.card-id-pdf-generator-modal__loading-title {
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;

}

.card-id-pdf-generator-modal__loading-title__spinner {
    border: 3px solid var(--white-color); 
    border-top: 3px solid var(--basic-green-color);
    border-bottom: 3px solid var(--basic-green-color);
    border-left: 3px solid var(--basic-green-color);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: spin 2s linear infinite;
    margin-left: 10px;
}

.card-id-pdf-generator-modal__loading .baloa-subtitle-1 {
    color: var(--primary-very-dark-color);   
}

.card-id-pdf-generator-modal__loading .baloa-normal {
    color: var(--primary-dark-color);
    margin-top: 20px;
}

.card-id-pdf-generator-modal__loading .baloa-table {
    color: var(--basic-gray-color);
    margin-top: 24px;
    margin-bottom: 140px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-card-id-pdf-generator-modal/TournamentCardIdPdfGeneratorModalComponent.styles.css"],"names":[],"mappings":"AAAA;AACA,UAAU;AACV;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,oCAAoC;IACpC,8CAA8C;IAC9C,iDAAiD;IACjD,+CAA+C;IAC/C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,oBAAoB;AACxB","sourcesContent":[".card-id-pdf-generator-modal .modal2__container{\nwidth: 80%;\n}\n\n.card-id-pdf-generator-modal__mobile-options {\n    padding: 50px 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.card-id-pdf-generator-modal__loading {\n    margin-top: 140px;\n    text-align: center;\n}\n\n.card-id-pdf-generator-modal__loading .hubicon-id_card {\n    font-size: 40px;\n    padding: 16px;\n    background: #DCFCE7;\n    border-radius: 50%;\n}\n\n.card-id-pdf-generator-modal__loading-title {\n    margin-top: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: auto;\n    margin-right: auto;\n\n}\n\n.card-id-pdf-generator-modal__loading-title__spinner {\n    border: 3px solid var(--white-color); \n    border-top: 3px solid var(--basic-green-color);\n    border-bottom: 3px solid var(--basic-green-color);\n    border-left: 3px solid var(--basic-green-color);\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    animation: spin 2s linear infinite;\n    margin-left: 10px;\n}\n\n.card-id-pdf-generator-modal__loading .baloa-subtitle-1 {\n    color: var(--primary-very-dark-color);   \n}\n\n.card-id-pdf-generator-modal__loading .baloa-normal {\n    color: var(--primary-dark-color);\n    margin-top: 20px;\n}\n\n.card-id-pdf-generator-modal__loading .baloa-table {\n    color: var(--basic-gray-color);\n    margin-top: 24px;\n    margin-bottom: 140px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
